import type { SelectOption } from '_atoms/Select/types';
import type { PromotionRequestListItem, PromotionRequestListOpening } from 'actions';

export interface PromotionRequestRow extends PromotionRequestListItem {
  openingsLabel: string[];
  [key: string]: unknown;
}

const openingLabel = (opening: PromotionRequestListOpening): string =>
  `${opening.custom_level || opening.level}${opening.is_prior ? ' (prior)' : ''}`;

export const dataMapper = (results: PromotionRequestListItem[] = []): PromotionRequestRow[] =>
  results.map(item => ({
    ...item,
    openingsLabel: (item.openings || []).map(openingLabel),
  }));

export interface TableSorting {
  field: string;
  key: string;
  order: string;
}

export interface PromotionRequestTableOptions {
  sorting: TableSorting;
  limit: { value: number; label: number };
  offset: number;
}

export const paramsMapper = (tableOptions: PromotionRequestTableOptions, statuses: SelectOption[] = []) => ({
  sorting_field: tableOptions.sorting.field,
  sorting: tableOptions.sorting.order,
  limit: tableOptions.limit.value,
  offset: tableOptions.offset,
  status: statuses.map(s => s.value).join(','),
});
